document.addEventListener('alpine:init', function(){

    Alpine.data('adev_new_list_collections', function(){
        return {
            searchQuery: '',
            
            get normalizedSearchWords() {
                if (!this.searchQuery) return [];
                return this.searchQuery.toLowerCase().split(/\s+/).map(word => latinize(word)).filter(word => word.length > 0);
            },

            get sectionRootId() {
                return '#' + this.$root.id;
            },

            styleTag: null,
            cssSearch() {
                if (!this.styleTag) {
                    this.styleTag = document.createElement('style');
                    document.head.appendChild(this.styleTag);

                    document.querySelectorAll('[data-adev-new-list-collections="item"]').forEach(col => {
                        const title = col.getAttribute('data-adev');
                        col.setAttribute('data-adev-lat', latinize(title));
                    });
                }

                let css = ``;

                const searchWords = this.normalizedSearchWords;

                if (searchWords.length < 1) {
                    this.styleTag.innerHTML = '';
                    return;
                }

                const id = this.sectionRootId;

                searchWords.forEach((searchWord, index) => {
                    css += `${id} .adev-cs__col:not([data-adev*="${searchWord}"]) { display: none !important; } `;
                    css += `${id} .adev-cs__col:not([data-adev-lat*="${searchWord}"]) { display: none !important; } `;
                    css += `${id} .adev-cs__col[data-adev-lat*="${searchWord}"] { display: block !important; } `;
                    css += `${id} .adev-cs__col[data-adev*="${searchWord}"] { display: block !important; } `;
                });

                this.styleTag.innerHTML = css;
            },
            
            // showIfContainsInSearch(title = '') {
            //     const searchWords = this.normalizedSearchWords;
                
            //     if (searchWords.length === 0) {
            //         return true;
            //     }

            //     const normalizedTitle = latinize(title.toLowerCase());
            //     const titleWords = normalizedTitle.split(/\s+/);

            //     // All search words must be found in the title
            //     for (const searchWord of searchWords) {
            //         let found = false;
                    
            //         for (const titleWord of titleWords) {
            //             if (titleWord.includes(searchWord)) {
            //                 found = true;
            //                 break;
            //             }
            //         }
                    
            //         if (!found) {
            //             return false;
            //         }
            //     }
                
            //     return true;
            // },

            init () {
                this.$watch('searchQuery', () => {
                    this.cssSearch();
                });
            }
        }
    });
    
});
